<template>
  <el-card class="box-card">
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          size="mini"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          size="mini"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="分组" prop="endDate">
        <el-select v-model="queryParams.type" size="mini" placeholder="请选择">
          <el-option
            v-for="item in groups"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>

    <div ref="chartContainer" style="width: 100%; height: 450px;" />
  </el-card>
</template>

<script>
import echarts from 'echarts'
import { getUserGroupDataStat } from '@/api/statistics/user_remain'
import { dateStrTodate, getLastDates } from '@/utils'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import storage from '@/utils/storage'
export default {
  name: 'UserGroupDataStat',
  data() {
    return {
      cachekey: 'UserGroupDataStat',
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      groups: [],
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.queryParams.type = 101
    this.getTables()
    this.getGroup()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: '用户分组数据分布'
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom',
          selected: {
            '登录人数': true,
            '人均在线时长': true,
            '付费率': true,
            '活跃留存': true,
            '体力发放': true,
            '人均体力发放': true,
            '体力消耗': true,
            '人均体力消耗': true,
            '人均次数': true,
            '人均下注': true,
            '净消耗': true
          }
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: [],
          axisLabel: {
            // rotate: 45 // 标签旋转45度
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables()
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      const cacheKey = this.cachekey
      const legendSelected = storage.get(cacheKey)
      this.loading = true
      getUserGroupDataStat(this.queryParams).then(res => {
        this.loading = false
        this.initChart()
        const date = []
        const legend = []
        const data = {}
        const result = res.data.data
        const keyMap = {
          'user': '登录人数',
          'online_avg': '人均在线时长',
          'pay_rate': '付费率',
          'user_remain': '活跃留存',
          'grant_spins': '体力发放',
          'grant_spins_avg': '人均体力发放',
          'cost_spins': '体力消耗',
          'cost_spins_avg': '人均体力消耗',
          'slot_avg': '人均次数',
          'bet_avg': '人均下注',
          'net_disbursements': '净消耗'
        }
        for (const i in result) {
          const val = result[i]
          date.push(dateStrTodate(val.date))
          for (const k in val) {
            if (k === 'date' || k === 'groupId') {
              continue
            }
            if (data[k] === undefined) {
              data[k] = []
            }
            data[k].push(val[k])
          }
        }

        for (const i in data) {
          const val = data[i]
          legend.push(keyMap[i])
          const temp = {
            name: keyMap[i],
            data: val,
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          }
          this.option.series.push(temp)
        }
        this.option.xAxis.data = date
        this.option.legend.data = legend
        if (legendSelected) {
          this.option.legend.selected = legendSelected
        }
        this.chart.setOption(this.option, true)
        this.chart.on('legendselectchanged', function(params) {
          storage.set(cacheKey, params.selected)
        })
      })
    }
  }
}
</script>

<style scoped>
.mtop{
  margin-top: 10px
}
</style>
